<template>
<!-- 错误分析 -->
  <div chass="app-container">
    <div class="chart-container">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-bottom:20px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>错误分析（功能完善中）</h5>
              </span>
            </div>
            <!-- <div style="width:100%;float:left">
              <div style="float:right;margin-right:10px;cursor: pointer;margin-left:10px" title="下载">
                <el-button slot="reference" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="exportExcel($event,'xiazaizhucequdaoliebiao')"></el-button>
              </div>
            </div> -->
            <div style="width:100%;float:left">

              <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'8px 6px !important'}" :data="tableData3.slice((currentPage3-1)*sizePage3,currentPage3*sizePage3)" class="tb-edit tb-edit1" border>
                <el-table-column prop="appChannelCode" label="时间" width="150">
                </el-table-column>
                <el-table-column prop="appChannelName" label="名称" width="200">
                </el-table-column>
                <el-table-column prop="channelCode" label="错误码" width="150">
                </el-table-column>
                <el-table-column prop="channelName" label="错误代码">
                  <template slot-scope="scope">
                    <div :style="{height : scope.row.open ? 'auto': '36px'}" style="border:1px solid #dedede;border-radius: 6px;padding:5px;overflow:hidden" v-html="scope.row[scope.column.property]"></div>
                    <el-button size="mini" style="padding:0px;position:absolute;top:10px;right:7px" type="text" @click="scope.row.open = !scope.row.open">{{scope.row.open ? '↑ 收起' : '↓ 展开'}}</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <div class="block" style="padding-bottom:10px">
                <el-pagination :current-page="currentPage3" :page-sizes="[10,15, 20, 30, 50]" :page-size="sizePage3" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5" :total="dataLength3" style="margin-top:10px;" @size-change="handleSizeChange3" @current-change="handleCurrentChange3" />
              </div>

              <el-table id="xiazaizhucequdaoliebiao" style="display: none;" :data="tableData3" class="tb-edit tb-edit1">
                <el-table-column prop="appChannelCode" label="时间">
                </el-table-column>
                <el-table-column prop="appChannelName" label="名称">
                </el-table-column>
                <el-table-column prop="channelCode" label="错误码">
                </el-table-column>
                <el-table-column prop="channelName" label="错误代码">
                  <template slot-scope="scope">
                    <div :style="{height : scope.row.open ? 'auto': '36px'}" style="border:1px solid #dedede;border-radius: 6px;padding:5px;overflow:hidden" v-html="scope.row[scope.column.property]"></div>
                    <el-button size="mini" style="padding:0px;position:absolute;top:10px;right:7px" type="text" @click="scope.row.open = !scope.row.open">{{scope.row.open ? '↑ 收起' : '↓ 展开'}}</el-button>
                  </template>
                </el-table-column>
              </el-table>

            </div>

          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
import { } from "@Bdc~/api/ajax_model";

export default {
  name: "",
  components: {},
  data() {
    return {

      tableData3: [],
      currentPage3: 1,
      dataLength3: 1,
      sizePage3: 10
    };
  },
  created() {
  },
  mounted() {},
  methods: {
    handleSizeChange3(e) {
      // table 分页数量变化
    },
    handleCurrentChange3(e) {
      // table 分页变化
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding:10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-edit1 tr td .cell {
  padding: 0px 10px !important;
}

.el-table th {
  background-color: #fff;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>
<style>
.aaa {
  text-align: center;
}
.shishitophuizong {
  width: 16.6%;
  float: left;
  text-align: center;
}
.shishitophuizong1 {
  font-size: 14px;
  font-weight: 600;
  padding: 5px 0px;
}
.shishitophuizong2 {
  font-size: 30px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong3 {
  font-size: 12px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong1 icon {
  width: 15px;
  height: 15px;
}

.shishitophuizonger {
  width: 16.6%;
  float: left;
  text-align: center;
  border-top: 1px solid #e7eaec;
  padding: 8px 0px;
  vertical-align: middle;
  color: #337ab7;
  font-size: 14px;
}
.el-tag {
  background: none;
  border: none;
}

.zhibiaoshuoming {
  font-size: 12px;
  color: #999;
}
.zhibiaoshuoming_title {
  font-size: 14px;
  color: #666;
  display: block;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
}
.el-loading-mask {
  z-index: 5;
}
.disqudao {
  display: none;
}

.tianjiastyle,
.tianjiastyle1 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}
.tianjiastyle_bg,
.tianjiastyle_bg1 {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
}
.tianjiastyle_content {
  width: 720px;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 50%;
  margin-left: -350px;
  border: 1px solid #dedede;
}
.tianjiastyle_content1 {
  width: 90%;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 5%;
  border: 1px solid #dedede;
}
.wubaobiao {
  width: 300px;
  height: 200px;
  text-align: center;
  background: #fff;
  margin-bottom: 600px;
  color: #1890ff;
  position: relative;
  left: 50%;
  margin-left: -150px;
  top: 150px;
}
</style>